export default "__VITE_ASSET__Cc2No0gG__"